import React from 'react';
import styled from 'styled-components';

import { Label } from 'rbx';

import {
  CheckBox,
  // TextArea,
  Radio,
  InputAddOn,
  // InputErrorMessage,
  // InputErrorMessage,
} from '../../../components/elements';

const Info = styled.p`
  color: #b0b0b0;
  font-size: 12px;
`;

const PaddingDiv = styled.div`
  padding: ${props => props.verticalPadding || '1rem'}
    ${props => props.horizontalPadding || '0rem'};
`;

const PaymentPolicy = ({
  values,
  errors,
  // touched,
  //   handleChange,
  //   handleBlur,
  setFieldValue,
  //   menuOptions,
  //   selectedMenuValue,
  //   onChangeMenu,
  //   place,
}) => (
  <div style={{ padding: '2rem' }}>
    <PaddingDiv>
      <Label className="is-flex">
        <div style={{ width: '250px' }}>
          Refund options for USER and PARTNER
        </div>
      </Label>
    </PaddingDiv>
    <div className="is-flex">
      <div style={{ paddingRight: '12px' }}>
        <CheckBox
          label="Reverse Transfer"
          value={values.reverse_transfer}
          disabled
        />
      </div>
      <CheckBox
        label="Refund Application Fee"
        value={values.refund_application_fee}
        disabled
      />
    </div>
    <PaddingDiv>
      <Label className="is-flex">
        <div style={{ width: '250px' }}>Customer can cancel booking</div>
      </Label>
      <Info>Please set this value in Table Booking Setting</Info>
    </PaddingDiv>
    <div className="is-flex">
      <div style={{ paddingRight: '12px' }}>
        <Radio
          label="Never"
          value={!values.cancel_booking}
          onChange={value => {
            if (value) {
              setFieldValue('cancel_booking', false);
            } else {
              setFieldValue('cancel_booking', true);
            }
          }}
          disabled
        />
      </div>

      <Radio
        label="Any Time"
        value={values.cancel_booking}
        onChange={value => {
          if (value) {
            setFieldValue('cancel_booking', true);
          } else {
            setFieldValue('cancel_booking', false);
          }
        }}
        disabled
      />
    </div>

    <PaddingDiv>
      <Label className="is-flex">
        <div style={{ width: '180px' }}>Cancellation Deadline</div>
        <input
          type="number"
          id="numberInput"
          name="numberInput"
          min="0"
          max="100"
          step="1"
          value={values.cut_off_time_in_hours}
          onChange={e => setFieldValue('cut_off_time_in_hours', e.target.value)}
          onBlur={e => {
            if (parseInt(e.target.value, 10) === 0) {
              setFieldValue('cut_off_time_in_hours', 0);
              setFieldValue('refund_before_cut_off_time', 'FULL');
              setFieldValue('refund_after_cut_off_time', 'FULL');
              setFieldValue('refund_fee_before_cut_off', '');
              setFieldValue('refund_fee_after_cut_off', '');
            } else if (e.target.value) {
              // pass
            } else {
              setFieldValue('cut_off_time_in_hours', 0);
              setFieldValue('refund_before_cut_off_time', 'FULL');
              setFieldValue('refund_after_cut_off_time', 'FULL');
              setFieldValue('refund_fee_before_cut_off', '');
              setFieldValue('refund_fee_after_cut_off', '');
            }
          }}
          disabled={!values.cancel_booking}
        />
        &nbsp; &nbsp;
        <div>hour (s)</div>
      </Label>
      <Info>
        Cancellation Notice - Number of hours before a booking can be cancelled
        withouth incurring a penalty fee
      </Info>
      {errors.cut_off_time_in_hours && (
        <p className="help is-danger is-size-4">
          {errors.cut_off_time_in_hours}
        </p>
      )}
    </PaddingDiv>

    {values.cut_off_time_in_hours === 0 ||
    values.cut_off_time_in_hours === '0' ? (
      <>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '250px' }}>Refund</div>
          </Label>
        </PaddingDiv>
        <div className="is-flex">
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="Full Refund"
              value={values.refund_before_cut_off_time === 'FULL'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_before_cut_off_time', 'FULL');
                  setFieldValue('refund_after_cut_off_time', 'FULL');
                  setFieldValue('refund_fee_before_cut_off', '');
                  setFieldValue('refund_fee_after_cut_off', '');
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="Partial Refund"
              value={values.refund_before_cut_off_time === 'PARTIAL'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_before_cut_off_time', 'PARTIAL');
                  setFieldValue('refund_after_cut_off_time', 'PARTIAL');
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="No Refund"
              value={values.refund_before_cut_off_time === 'NO_REFUND'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_before_cut_off_time', 'NO_REFUND');
                  setFieldValue('refund_after_cut_off_time', 'NO_REFUND');
                  setFieldValue('refund_fee_before_cut_off', '');
                  setFieldValue('refund_fee_after_cut_off', '');
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
        </div>
        {values.refund_before_cut_off_time === 'PARTIAL' && (
          <PaddingDiv>
            <Label className="is-flex">
              <div style={{ width: '250px' }}>Partial Cancellation Fee</div>
              <InputAddOn
                addonsText="$"
                isLeft
                type="number"
                id="numberInput"
                name="numberInput"
                min="0"
                max="100"
                step="0.01"
                value={values.refund_fee_before_cut_off}
                onChange={e => {
                  setFieldValue('refund_fee_before_cut_off', e.target.value);
                  setFieldValue('refund_fee_after_cut_off', e.target.value);
                }}
                disabled={
                  !values.cancel_booking ||
                  values.refund_before_cut_off_time !== 'PARTIAL'
                }
              />
              &nbsp; &nbsp;
              <div>per user / booking</div>
            </Label>
            <Info>Cancellation Fee paid by the customer.</Info>
            {errors.refund_fee_before_cut_off && (
              <p className="help is-danger is-size-4">
                {errors.refund_fee_before_cut_off}
              </p>
            )}
          </PaddingDiv>
        )}
      </>
    ) : (
      <>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '250px' }}>Refund before deadline</div>
          </Label>
        </PaddingDiv>
        <div className="is-flex">
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="Full Refund"
              value={values.refund_before_cut_off_time === 'FULL'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_before_cut_off_time', 'FULL');
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="Partial Refund"
              value={values.refund_before_cut_off_time === 'PARTIAL'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_before_cut_off_time', 'PARTIAL');
                  if (values.refund_after_cut_off_time === 'FULL') {
                    setFieldValue('refund_after_cut_off_time', 'PARTIAL');
                  }
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="No Refund"
              value={values.refund_before_cut_off_time === 'NO_REFUND'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_before_cut_off_time', 'NO_REFUND');
                  if (values.refund_after_cut_off_time === 'FULL') {
                    setFieldValue('refund_after_cut_off_time', 'NO_REFUND');
                  } else if (values.refund_after_cut_off_time === 'PARTIAL') {
                    setFieldValue('refund_after_cut_off_time', 'NO_REFUND');
                  }
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
        </div>
        {values.refund_before_cut_off_time === 'PARTIAL' && (
          <PaddingDiv>
            <Label className="is-flex">
              <div style={{ width: '250px' }}>
                Partial Cancellation Fee Before Deadline
              </div>
              <InputAddOn
                addonsText="$"
                isLeft
                type="number"
                id="numberInput"
                name="numberInput"
                min="0"
                max="100"
                step="0.01"
                value={values.refund_fee_before_cut_off}
                onChange={e =>
                  setFieldValue('refund_fee_before_cut_off', e.target.value)
                }
                disabled={
                  !values.cancel_booking ||
                  values.refund_before_cut_off_time !== 'PARTIAL'
                }
              />
              &nbsp; &nbsp;
              <div>per user / booking</div>
            </Label>
            <Info>
              Cancellation Fee paid by the customer before the Cut-off.
            </Info>
            {errors.refund_fee_before_cut_off && (
              <p className="help is-danger is-size-4">
                {errors.refund_fee_before_cut_off}
              </p>
            )}
          </PaddingDiv>
        )}

        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '250px' }}>Refund after deadline</div>
          </Label>
        </PaddingDiv>
        <div className="is-flex">
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="Full Refund"
              value={values.refund_after_cut_off_time === 'FULL'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_after_cut_off_time', 'FULL');
                }
              }}
              disabled={
                !values.cancel_booking ||
                values.refund_before_cut_off_time === 'PARTIAL' ||
                values.refund_before_cut_off_time === 'NO_REFUND'
              }
            />
          </div>
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="Partial Refund"
              value={values.refund_after_cut_off_time === 'PARTIAL'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_after_cut_off_time', 'PARTIAL');
                }
              }}
              disabled={
                !values.cancel_booking ||
                values.refund_before_cut_off_time === 'NO_REFUND'
              }
            />
          </div>
          <div style={{ paddingRight: '12px' }}>
            <Radio
              label="No Refund"
              value={values.refund_after_cut_off_time === 'NO_REFUND'}
              onChange={value => {
                if (value) {
                  setFieldValue('refund_after_cut_off_time', 'NO_REFUND');
                }
              }}
              disabled={!values.cancel_booking}
            />
          </div>
        </div>

        {values.refund_after_cut_off_time === 'PARTIAL' && (
          <PaddingDiv>
            <Label className="is-flex">
              <div style={{ width: '250px' }}>
                Partial Cancellation Fee After Deadline
              </div>
              <InputAddOn
                addonsText="$"
                isLeft
                type="number"
                id="numberInput"
                name="numberInput"
                min="0"
                max="100"
                step="0.01"
                value={values.refund_fee_after_cut_off}
                onChange={e =>
                  setFieldValue('refund_fee_after_cut_off', e.target.value)
                }
                disabled={
                  !values.cancel_booking ||
                  values.refund_after_cut_off_time !== 'PARTIAL'
                }
              />
              &nbsp; &nbsp;
              <div>per user / booking</div>
            </Label>
            <Info>
              Cancellation Fee paid by the customer after the Cut-off has passed
            </Info>
            {errors.refund_fee_after_cut_off && (
              <p className="help is-danger is-size-4">
                {errors.refund_fee_after_cut_off}
              </p>
            )}
          </PaddingDiv>
        )}
      </>
    )}

    <>
      <PaddingDiv>
        <Label className="is-flex">
          <div style={{ width: '250px' }}>Customer can modify booking</div>
        </Label>
      </PaddingDiv>
      <div className="is-flex">
        <div style={{ paddingRight: '12px' }}>
          <Radio
            label="Any Time"
            value={values.modify_booking === 'ANY_TIME'}
            onChange={value => {
              if (value) {
                setFieldValue('modify_booking', 'ANY_TIME');
                setFieldValue('modify_cutoff_time', '');
              }
            }}
            disabled={!values.cancel_booking}
          />
        </div>
        <div style={{ paddingRight: '12px' }}>
          <Radio
            label="Never"
            value={values.modify_booking === 'NEVER'}
            onChange={value => {
              if (value) {
                setFieldValue('modify_booking', 'NEVER');
                setFieldValue('modify_cutoff_time', '');
              }
            }}
            disabled={!values.cancel_booking}
          />
        </div>
        <div style={{ paddingRight: '12px' }}>
          <Radio
            label="Till Cut-off time"
            value={values.modify_booking === 'BEFORE_CUT_OFF'}
            onChange={value => {
              if (value) {
                setFieldValue('modify_booking', 'BEFORE_CUT_OFF');
                setFieldValue('modify_cutoff_time', '');
              }
            }}
            disabled={!values.cancel_booking}
          />
        </div>
      </div>
      {values.modify_booking === 'BEFORE_CUT_OFF' && (
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '180px' }}>Modify Cut-off Time</div>
            <input
              type="number"
              id="numberInput"
              name="numberInput"
              min="0"
              max="100"
              step="1"
              value={values.modify_cutoff_time}
              onChange={e =>
                setFieldValue('modify_cutoff_time', e.target.value)
              }
              onBlur={e => {
                if (parseInt(e.target.value, 10) === 0) {
                  setFieldValue('modify_cutoff_time', 0);
                } else if (e.target.value) {
                  // pass
                } else {
                  setFieldValue('modify_cutoff_time', 0);
                }
              }}
              disabled={!values.cancel_booking}
            />
            &nbsp; &nbsp;
            <div>hour (s)</div>
          </Label>
          {errors.modify_cutoff_time && (
            <p className="help is-danger is-size-4">
              {errors.modify_cutoff_time}
            </p>
          )}
        </PaddingDiv>
      )}
    </>

    <PaddingDiv>
      <Label className="is-flex">
        <div style={{ width: '250px' }}>No Show Process</div>
      </Label>
    </PaddingDiv>
    <div className="is-flex">
      <div style={{ paddingRight: '12px' }}>
        <Radio
          label="Full Refund"
          value={values.no_show_refund === 'FULL'}
          disabled
        />
      </div>
      <div style={{ paddingRight: '12px' }}>
        <Radio
          label="Partial Refund"
          value={values.no_show_refund === 'PARTIAL'}
          disabled
        />
      </div>
      <div style={{ paddingRight: '12px' }}>
        <Radio
          label="No Refund"
          value={values.no_show_refund === 'NO_REFUND'}
          disabled
        />
      </div>
    </div>

    {values.no_show_refund === 'PARTIAL' && (
      <PaddingDiv>
        <Label className="is-flex">
          <div style={{ width: '250px' }}>Partial Refund</div>
          <InputAddOn
            addonsText="$"
            isLeft
            type="number"
            id="numberInput"
            name="numberInput"
            min="0"
            max="100"
            step="0.01"
            value={values.no_show_fee_refund}
            onChange={e => setFieldValue('no_show_fee_refund', e.target.value)}
            disabled={
              !values.cancel_booking || values.no_show_refund !== 'PARTIAL'
            }
          />
          &nbsp; &nbsp;
          <div>per user / booking</div>
        </Label>
        <Info>
          Cancellation Fee paid by the customer after the Cut-off has passed
        </Info>
        {errors.no_show_fee_refund && (
          <p className="help is-danger is-size-4">
            {errors.no_show_fee_refund}
          </p>
        )}
      </PaddingDiv>
    )}

    <Info>Note: Processing fee will not be refunded</Info>
    <br />
  </div>
);

export default PaymentPolicy;
